import {useQuery} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {ProductionStepMaterialCondition, ProductionStepModalState, ProductionStepProp} from './production-step.models';
import {productionStepQueryKeys} from '../production-step-query-keys';
import {EnvisiaObjects} from '../../../common/wrapper.models';
import {EvObjectsLoadingSwitchModel} from '../../components/loading/ev-loading-list.model';

export function useProductionStepMaterialListQuery(
  props: ProductionStepProp & ProductionStepModalState,
): EvObjectsLoadingSwitchModel<ProductionStepMaterialCondition> {
  const {data, status} = useQuery({
    queryKey: productionStepQueryKeys.materialConditionsList(props.productionStepId),
    queryFn: () =>
      AxiosHttpClient.get<EnvisiaObjects<ProductionStepMaterialCondition>>(
        `${environment.apiv4uri}article/config/production/step/${props.productionStepId}/material/conditions`),
    enabled: props.modal === 'open',
  });

  return {
    objects: data?.objects ?? [],
    status: status,
  };
}
